import { api } from './client';
import type { TipListResponse, TipCreateResponse, TipUpdateResponse } from './types';

export function getTips(params: { page: number; limit?: number; frameworkId?: string }) {
  const qs = new URLSearchParams({ page: String(params.page) });
  if (params.limit) qs.set('limit', String(params.limit));
  if (params.frameworkId) qs.set('framework_id', params.frameworkId);
  return api.get<TipListResponse>(`/api/admin/tips?${qs}`);
}

export function createTip(body: { text: string; framework_id?: string | null; is_active?: number }) {
  return api.post<TipCreateResponse>('/api/admin/tips', body);
}

export function updateTip(id: number, body: { text?: string; framework_id?: string | null; is_active?: number }) {
  return api.put<TipUpdateResponse>(`/api/admin/tips/${id}`, body);
}

export function deleteTip(id: number) {
  return api.del<{ deleted: boolean }>(`/api/admin/tips/${id}`);
}
